import { memo } from "react";
import Portal from "../Portal/Portal";
import LessonSettingsContainer from "./LessonSettingsContainer";
import "./LessonSettings.styles.css";
import { connect } from "react-redux";

function LessonSettings(props: any) {
  if (!props.lessonSettingsController.isOpen) {
    return null;
  }

  return (
    <Portal path={"lesson-settings"} keepOn={props.lessonSettingsController.isOpen}>
      <LessonSettingsContainer {...props} />
    </Portal>
  );
}

const mapProps = (state: any) => {
  return {
    isCpatUser: state.authorizedState.isCpatUser,
  };
};
export default connect(mapProps, null)(memo(LessonSettings));
